import gamerdairy from '../../Assets/Images/gamerdairy.png';
import postman from '../Images/postman.png';

export const AchievementsData = [
  {
    title: 'Top 9 in Hacksprint v3.0',
    link: '',
    imageSrc: gamerdairy,
    headline: 'Insert Awesome Shapes into Your React Site with Ease.',
    description:
      'There are so many amzing shapes like star, cross, donut, circle, etc which one can use as a component in react and display it as their requirements!',
    color: '#D6FF79'
    // width: "200px",
    // height: "200px",
  },
  {
    title: 'Postman Student Expert',
    link: '',
    headline: 'Completed Hacktoberfest 2021',
    description:
      "Hacktoberfest is a yearly event to encourage people to contribute to open source in October. It's a celebration of community, learning and giving back—topped off by DigitalOcean thanking participants. ",
    imageSrc: postman,
    color: '#FF8126ee'
    // width: "140px",
    // height: "140px",
  }
];
